import vbImg52 from "../../assets/products/viewboard/ifp52/ifp52_Education.png";
import vbImg52Crop from "../../assets/products/viewboard/ifp52/IFP52_Corporate.png";
import vbImg52Class from "../../assets/products/viewboard/ifp52/IFP52_Classroom.png";
import vbImg52Board from "../../assets/products/viewboard/ifp52/IFP52_Boardroom.png";
import vbImg522f from "../../assets/products/viewboard/IFP52-2F/IFP52-2F_Education.png"
import vbImg522fCrop from "../../assets/products/viewboard/IFP52-2F/IFP52-2F_Corporate.png";
import vbImg522fClass from "../../assets/products/viewboard/IFP52-2F/IFP52-2F_Classroom.png";
import vbImg522fBoard from "../../assets/products/viewboard/IFP52-2F/IFP52-2F_Boardroom.png";
import vbImg32 from "../../assets/products/viewboard/ifp32/IFP32_Education.png";
import vbImg32Crop from "../../assets/products/viewboard/ifp32/IFP32_Corporate.png";
import vbImg32Class from "../../assets/products/viewboard/ifp32/IFP32_Classroom.png";
import vbImg32Board from "../../assets/products/viewboard/ifp32/IFP32_Boardroom.png";
import vbImg33 from "../../assets/products/viewboard/IFP33/IFP33_Education.png";
import vbImg33Board from "../../assets/products/viewboard/IFP33/IFP33_Boardroom.png";
import vbImg33Class from "../../assets/products/viewboard/IFP33/IFP33_Classroom.png";
import vbImg33Crop from "../../assets/products/viewboard/IFP33/IFP33_Corporate.png";
import vbImg55g1 from "../../assets/products/viewboard/IFPGenesis/IFPGenesis_Education.png";
import vbImg55g1Board from "../../assets/products/viewboard/IFPGenesis/IFPGenesis_Boardroom.png";
import vbImg55g1Class from "../../assets/products/viewboard/IFPGenesis/IFPGenesis_Classroom.png";
import vbImg55g1Crop from "../../assets/products/viewboard/IFPGenesis/IFPGenesis_Corporate.png";
import vbImg62 from "../../assets/products/viewboard/ifp62/IFP62_Education.png";
import vbImg62Crop from "../../assets/products/viewboard/ifp62/IFP62_Corporate.png";
import vbImg62Class from "../../assets/products/viewboard/ifp62/IFP62_Classroom.png";
import vbImg62Board from "../../assets/products/viewboard/ifp62/IFP62_Boardroom.png";
import vbImg50 from "../../assets/products/viewboard/ifp50/ifp50_Education.png";
import vbImg50Crop from "../../assets/products/viewboard/ifp50/IFP50_Corporate.png";
import vbImg50Class from "../../assets/products/viewboard/ifp50/IFP50_Classroom.png";
import vbImg50Board from "../../assets/products/viewboard/ifp50/IFP50_Boardroom.png";
import lds138CropImg from "../../assets/products/allInOne/lds/LDS138-coporate.png";
import lds138CampusImg from "../../assets/products/allInOne/lds/LDS138-campus.png";
import ldc027Cover from "../../assets/products/allInOne/LDC027/LDC027-Product Photo_F01.jpeg";
import ldc031Cover from "../../assets/products/allInOne/LDC031/LDC031-Product.jpeg";
import ldp136Cover from "../../assets/products/allInOne/LDP/LDP136.jpeg";
import ldp163Cover from "../../assets/products/allInOne/LDP/LDP163.jpeg";
import vbImgultrawide from "../../assets/products/viewboard/IFPUltrawide/IFPUltrawide_Education.png";
import vbImgultrawideCrop from "../../assets/products/viewboard/IFPUltrawide/IFPUltrawide_Corporate.png";
import vbImgultrawideClass from "../../assets/products/viewboard/IFPUltrawide/IFPUltrawide_Classroom.png";
import vbImgultrawideBoard from "../../assets/products/viewboard/IFPUltrawide/IFPUltrawide_Boardroom.png";
import vbImg110 from "../../assets/products/viewboard/IFP110/IFP110_Education.png";
import vbImg110Crop from "../../assets/products/viewboard/IFP110/IFP110_Corporate.png";
import vbImg110Class from "../../assets/products/viewboard/IFP110/IFP110_Classroom.png";
import vbImg110Board from "../../assets/products/viewboard/IFP110/IFP110_Boardroom.png";
import vbImg9850 from "../../assets/products/viewboard/ifp9850/ifp9850_education.png";
import vbImg9850Crop from "../../assets/products/viewboard/ifp9850/ifp9850_corporate.png";
import vbImg9850Class from "../../assets/products/viewboard/ifp9850/ifp9850_classroom.png";
import vbImg9850Board from "../../assets/products/viewboard/ifp9850/ifp9850_boardroom.png";
import cde30ImgBoard from "../../assets/products/commercial_display/CDE30/CDE30_boardroom.png";
import cde30ImgCampus from "../../assets/products/commercial_display/CDE30/CDE30_campus.png";
import cde30ImgCampusV from "../../assets/products/commercial_display/CDE30/CDE30_Campus_Vertical.png";
import cde30ImgCrop from "../../assets/products/commercial_display/CDE30/CDE30_corporate.png";
import cde30ImgCropV from "../../assets/products/commercial_display/CDE30/CDE30_Corporate_Vertical.png";
import cde30ImgRetail from "../../assets/products/commercial_display/CDE30/CDE30_Retail.png";
import cde30ImgRetailV from "../../assets/products/commercial_display/CDE30/CDE30_Retail_Vertical.png";
import cde92uwBoard from "../../assets/products/commercial_display/CDEUW/CDE92UW_Boardroom.png";
import cde92uwCampus from "../../assets/products/commercial_display/CDEUW/CDE92UW_Campus.png";
import cde92uwCampusV from "../../assets/products/commercial_display/CDEUW/CDE92UW_Campus_Vertical.png";
import cde92uwCrop from "../../assets/products/commercial_display/CDEUW/CDE92UW_Corperate.png";
import cde92uwCropV from "../../assets/products/commercial_display/CDEUW/CDE92UW_Corporate_Vertical.png";
import cde92uwRetail from "../../assets/products/commercial_display/CDEUW/CDE92UW_Retail.png";
import cde92uwRetailV from "../../assets/products/commercial_display/CDEUW/CDE92UW_Retail_Vertical.png"
import cde4314Img from "../../assets/products/commercial_display/CDE14/25-PTD-CDE4314-Product Photo_F01.jpg";
import cde5014Img from "../../assets/products/commercial_display/CDE14/25-PTD-CDE5014-Product Photo_F01.jpg";
import cde5514Img from "../../assets/products/commercial_display/CDE14/25-PTD-CDE5514-Product Photo_F01.jpg";
import cde6514Img from "../../assets/products/commercial_display/CDE14/25-PTD-CDE6514-Product Photo_F01.jpg";
import cde7514Img from "../../assets/products/commercial_display/CDE14/25-PTD-CDE7514-Product Photo_F01.jpg";
import cde8614Img from "../../assets/products/commercial_display/CDE14/25-PTD-CDE8614-Product Photo_F01.jpg";
import cde14ImgBoard from "../../assets/products/commercial_display/CDE14/commercial-boardroom.jpeg";
import cde14ImgCampus from "../../assets/products/commercial_display/CDE14/commercial-campus.jpeg";
import cde14ImgCampusV from "../../assets/products/commercial_display/CDE14/commercial-campus-vertical.jpeg";
import cde14ImgRetail from "../../assets/products/commercial_display/CDE14/commercial-retail.jpeg";
import cde14ImgRetailV from "../../assets/products/commercial_display/CDE14/commercial-retail-vertical.jpeg";
import cde4331ImgH from "../../assets/products/commercial_display/CDE31/25-PTD-CDE4331-Product Photo_F01.jpg";
import cde4331ImgV from "../../assets/products/commercial_display/CDE31/25-PTD-CDE4331-Product Photo-portrait_B02.jpg";
import cde5531ImgH from "../../assets/products/commercial_display/CDE31/25-PTD-CDE5531-Product Photo_F01.jpg";
import cde5531ImgV from "../../assets/products/commercial_display/CDE31/25-PTD-CDE5531-Product Photo-portrait_B02.jpg";
import cde6531ImgH from "../../assets/products/commercial_display/CDE31/25-PTD-CDE6531-Product Photo_F01.jpg";
import cde6531ImgV from "../../assets/products/commercial_display/CDE31/25-PTD-CDE6531-Product Photo-portrait_B02.jpg";
import cde7531ImgH from "../../assets/products/commercial_display/CDE31/25-PTD-CDE7531-Product Photo_F01.jpg";
import cde7531ImgV from "../../assets/products/commercial_display/CDE31/25-PTD-CDE7531-Product Photo-portrait_B02.jpg";
import cde8631ImgH from "../../assets/products/commercial_display/CDE31/25-PTD-CDE8631-Product Photo_F01.jpg";
import cde8631ImgV from "../../assets/products/commercial_display/CDE31/25-PTD-CDE8631-Product Photo-portrait_B02.jpg";
import cde9831ImgH from "../../assets/products/commercial_display/CDE31/25-PTD-CDE9831-Product Photo_F01.jpg";
import cde9831ImgV from "../../assets/products/commercial_display/CDE31/25-PTD-CDE9831-Product Photo-portrait_B02.jpg";
import cde31ImgBoard from "../../assets/products/commercial_display/CDE31/commercial-boardroom.jpeg";
import cde31ImgCampus from "../../assets/products/commercial_display/CDE31/commercial-campus.jpeg";
import cde31ImgCampusV from "../../assets/products/commercial_display/CDE31/commercial-campus-vertical.jpeg";
import cde31ImgRetail from "../../assets/products/commercial_display/CDE31/commercial-retail.jpeg";
import cde31ImgRetailV from "../../assets/products/commercial_display/CDE31/commercial-retail-vertical.jpeg";
import cde43g3Img from "../../assets/products/commercial_display/CDEG3/25-PTD-CDE43G3-Product Photo_F01.jpg";
import cde55g3Img from "../../assets/products/commercial_display/CDEG3/25-PTD-CDE55G3-Product Photo_F01.jpg";
import cde65g3Img from "../../assets/products/commercial_display/CDEG3/25-PTD-CDE65G3-Product Photo_F01.jpg";
import cde75g3Img from "../../assets/products/commercial_display/CDEG3/25-PTD-CDE75G3-Product Photo_F01.jpg";
import cde86g3Img from "../../assets/products/commercial_display/CDEG3/25-PTD-CDE86G3-Product Photo_F01.jpg";
import cde98g3Img from "../../assets/products/commercial_display/CDEG3/25-PTD-CDE98G3-Product Photo_F01.jpg";
import cde43g3ImgBoard from "../../assets/products/commercial_display/CDEG3/commercial-boardroom.jpeg";
import cde43g3ImgCampus from "../../assets/products/commercial_display/CDEG3/commercial-campus.jpeg";
import cde43g3ImgCampusV from "../../assets/products/commercial_display/CDEG3/commercial-campus-vertical.jpeg";
import cde43g3ImgRetail from "../../assets/products/commercial_display/CDEG3/commercial-retail.jpeg";
import cde43g3ImgRetailV from "../../assets/products/commercial_display/CDEG3/commercial-retail-vertical.jpeg";
import lde136Photo from "../../assets/products/allInOne/lde/25-DVLED-LDE136G-152-Product Photo-F01.png";
import ldm136Crop from "../../assets/products/allInOne/ldm/LDM136-151.png";
import ldm163Crop from "../../assets/products/allInOne/ldm/LDM163-182.png";
import ldm231Crop from "../../assets/products/allInOne/ldm/LDM231-251.png";

const viewboardDetails = {
    viewboard: {
        seriesName: "Interactive Displays",
        series: {
            series522f: {
                name: "IFP52-2F Series",
                series: "52_2f",
                size: [
                    { id: "522f_option1", size: "65", model: "#ifp6552-2f" },
                    { id: "522f_option2", size: "75", model: "#ifp7552-2f" },
                    { id: "522f_option3", size: "86", model: "#ifp8652-2f" },
                ],
                inscreen_graphic: [
                    { label: "Education", value: "edu", id: "inlineRadio52_2f1" },
                    { label: "Corporate", value: "crop", id: "inlineRadio52_2f2" },
                    {
                        label: "Classroom",
                        value: "class",
                        id: "inlineRadio52_2f3",
                    },
                    {
                        label: "Boardroom",
                        value: "board",
                        id: "inlineRadio52_2f4",
                    },
                ],
                imageMapping: {
                    edu: vbImg522f,
                    crop: vbImg522fCrop,
                    class: vbImg522fClass,
                    board: vbImg522fBoard,
                },
            },
            series33: {
                name: "IFP33 Series",
                series: "33",
                size: [
                    { id: "option1", size: "65", model: "#ifp6533" },
                    { id: "option2", size: "75", model: "#ifp7533" },
                    { id: "option3", size: "86", model: "#ifp8633" },
                ],
                inscreen_graphic: [
                    { label: "Education", value: "edu", id: "inlineRadio331" },
                    { label: "Corporate", value: "crop", id: "inlineRadio332" },
                    {
                        label: "Classroom",
                        value: "class",
                        id: "inlineRadio333",
                    },
                    {
                        label: "Boardroom",
                        value: "board",
                        id: "inlineRadio334",
                    },
                ],
                imageMapping: {
                    edu: vbImg33,
                    crop: vbImg33Crop,
                    class: vbImg33Class,
                    board: vbImg33Board,
                },
            },
            ifpg1: {
                name: "IFPG1 Genesis Series OS-Free",
                series: "g1",
                size: [
                    { id: "g1_option1", size: "55", model: "#ifp55g1" },
                    { id: "g1_option2", size: "65", model: "#ifp65g1" },
                    { id: "g1_option3", size: "75", model: "#ifp75g1" },
                    { id: "g1_option4", size: "86", model: "#ifp86g1" },
                ],
                inscreen_graphic: [
                    { label: "Education", value: "edu", id: "inlineRadio_g1_1" },
                    { label: "Corporate", value: "crop", id: "inlineRadio_g1_2" },
                    {
                        label: "Classroom",
                        value: "class",
                        id: "inlineRadio_g1_3",
                    },
                    {
                        label: "Boardroom",
                        value: "board",
                        id: "inlineRadio_g1_4",
                    },
                ],
                imageMapping: {
                    edu: vbImg55g1,
                    crop: vbImg55g1Crop,
                    class: vbImg55g1Class,
                    board: vbImg55g1Board,
                },
            },
            seriesultrawide: {
                name: "IFP Ultrawide Series",
                series: "ultrawide",
                size: [
                    { id: "option1", size: "105", model: "#ifp105uw" },
                ],
                inscreen_graphic: [
                    {
                        label: "Education",
                        value: "edu",
                        id: "inlineRadioultrawidee",
                    },
                    {
                        label: "Corporate",
                        value: "crop",
                        id: "inlineRadioultrawidec",
                    },
                    {
                        label: "Classroom",
                        value: "class",
                        id: "inlineRadioultrawidecl",
                    },
                    {
                        label: "Boardroom",
                        value: "board",
                        id: "inlineRadioultrawideb",
                    },
                ],
                imageMapping: {
                    edu: vbImgultrawide,
                    crop: vbImgultrawideCrop,
                    class: vbImgultrawideClass,
                    board: vbImgultrawideBoard,
                },
            },
            series110: {
                name: "IFP110 Series",
                series: "110",
                size: [{ id: "ifp110_option1", size: "110", model: "#ifp110" }],
                inscreen_graphic: [
                    {
                        label: "Education",
                        value: "edu",
                        id: "inlineRadio110_1",
                    },
                    {
                        label: "Corporate",
                        value: "crop",
                        id: "inlineRadio110_2",
                    },
                    {
                        label: "Classroom",
                        value: "class",
                        id: "inlineRadio110_3",
                    },
                    {
                        label: "Boardroom",
                        value: "board",
                        id: "inlineRadio110_4",
                    },
                ],
                imageMapping: {
                    edu: vbImg110,
                    crop: vbImg110Crop,
                    class: vbImg110Class,
                    board: vbImg110Board,
                },
            },
            series62: {
                name: "IFP62 Series",
                series: "62",
                size: [
                    { id: "option10", size: "65", model: "#ifp6562" },
                    { id: "option11", size: "75", model: "#ifp7562" },
                    { id: "option12", size: "86", model: "#ifp8662" },
                ],
                inscreen_graphic: [
                    { label: "Education", value: "edu", id: "inlineRadio621" },
                    { label: "Corporate", value: "crop", id: "inlineRadio622" },
                    {
                        label: "Classroom",
                        value: "class",
                        id: "inlineRadio623",
                    },
                    {
                        label: "Boardroom",
                        value: "board",
                        id: "inlineRadio624",
                    },
                ],
                imageMapping: {
                    edu: vbImg62,
                    crop: vbImg62Crop,
                    class: vbImg62Class,
                    board: vbImg62Board,
                },
            },
            series50: {
                name: "IFP50 Series",
                series: "50",
                size: [
                    { id: "option4", size: "65", model: "#ifp6550" },
                    { id: "option5", size: "75", model: "#ifp7550" },
                    { id: "option6", size: "86", model: "#ifp8650" },
                    { id: "option50_98", size: "98", model: "#ifp9850-4" },
                ],
                inscreen_graphic: [
                    { label: "Education", value: "edu", id: "inlineRadi501" },
                    { label: "Corporate", value: "crop", id: "inlineRadio502" },
                    {
                        label: "Classroom",
                        value: "class",
                        id: "inlineRadio503",
                    },
                    {
                        label: "Boardroom",
                        value: "board",
                        id: "inlineRadio504",
                    },
                ],
                imageMapping: {
                    edu: vbImg50,
                    crop: vbImg50Crop,
                    class: vbImg50Class,
                    board: vbImg50Board,
                },
                imageMappingBySize: {
                    "#ifp9850-4": {
                        edu: vbImg9850,
                        crop: vbImg9850Crop,
                        class: vbImg9850Class,
                        board: vbImg9850Board,
                    },
                },
            },
            series51: {
                name: "IFP51 Series",
                series: "51",
                size: [
                    { id: "51_option1", size: "55", model: "#ifp5551" },
                    { id: "51_option2", size: "65", model: "#ifp6551" },
                    { id: "51_option3", size: "75", model: "#ifp7551" },
                    { id: "51_option4", size: "86", model: "#ifp8651" },
                    { id: "51_option5", size: "98", model: "#ifp9851" },
                ],
                inscreen_graphic: [
                    { label: "Education", value: "edu", id: "inlineRadio511" },
                ],
                imageMapping: {
                    edu: vbImg50,
                },
            },
            series52: {
                name: "IFP52 Series",
                series: "52",
                size: [
                    { id: "52_option1", size: "65", model: "#ifp6552" },
                    { id: "52_option2", size: "75", model: "#ifp7552" },
                    { id: "52_option3", size: "86", model: "#ifp8652" },
                ],
                inscreen_graphic: [
                    { label: "Education", value: "edu", id: "inlineRadio521" },
                    { label: "Corporate", value: "crop", id: "inlineRadio522" },
                    {
                        label: "Classroom",
                        value: "class",
                        id: "inlineRadio523",
                    },
                    {
                        label: "Boardroom",
                        value: "board",
                        id: "inlineRadio524",
                    },
                ],
                imageMapping: {
                    edu: vbImg52,
                    crop: vbImg52Crop,
                    class: vbImg52Class,
                    board: vbImg52Board,
                },
            },
            series32: {
                name: "IFP32 Series",
                series: "32",
                size: [
                    { id: "option7", size: "65", model: "#ifp6532" },
                    { id: "option8", size: "75", model: "#ifp7532" },
                    { id: "option9", size: "86", model: "#ifp8632" },
                ],
                inscreen_graphic: [
                    { label: "Education", value: "edu", id: "inlineRadio321" },
                    { label: "Corporate", value: "crop", id: "inlineRadio322" },
                    {
                        label: "Classroom",
                        value: "class",
                        id: "inlineRadio323",
                    },
                    {
                        label: "Boardroom",
                        value: "board",
                        id: "inlineRadio324",
                    },
                ],
                imageMapping: {
                    edu: vbImg32,
                    crop: vbImg32Crop,
                    class: vbImg32Class,
                    board: vbImg32Board,
                },
            },
        },
    },
    CDE: {
        seriesName: "Commercial Displays",
        series: {
            CDE30: {
                name: "CDE30 Series",
                size: [
                    { id: "option1", size: "43", model: "#CDE4330" },
                    { id: "option2", size: "55", model: "#CDE5530" },
                    { id: "option3", size: "65", model: "#CDE6530" },
                    { id: "option4", size: "75", model: "#CDE7530" },
                    { id: "option5", size: "86", model: "#CDE8630" },
                    { id: "option6", size: "98", model: "#CDE9830" },
                ],
                inscreen_graphic: [
                    {
                        id: "inlineRadio1",
                        label: "Corporate",
                        value: "crop",
                    },
                    {
                        id: "inlineRadio2",
                        label: "Campus",
                        value: "campus",
                    },
                    {
                        id: "inlineRadio3",
                        label: "Boardroom",
                        value: "board",
                    },
                    {
                        id: "inlineRadio4",
                        label: "Retail",
                        value: "retail",
                    },
                ],
                orientation: [
                    {
                        id: "crop",
                        options: [
                            { id: "orientation1", label: "Horizontal", value: "", disabled: false },
                            { id: "orientation2", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                    {
                        id: "campus",
                        options: [
                            { id: "orientation1", label: "Horizontal", value: "", disabled: false },
                            { id: "orientation2", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                    {
                        id: "board",
                        options: [
                            { id: "orientation1", label: "Horizontal", value: "", disabled: false },
                            { id: "orientation2", label: "Vertical", value: "V", disabled: true },
                        ],
                    },
                    {
                        id: "retail",
                        options: [
                            { id: "orientation1", label: "Horizontal", value: "", disabled: false },
                            { id: "orientation2", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                ],
                imageMapping: {
                    crop: cde30ImgCrop,
                    cropV: cde30ImgCropV,
                    campus: cde30ImgCampus,
                    campusV: cde30ImgCampusV,
                    board: cde30ImgBoard,
                    retail: cde30ImgRetail,
                    retailV: cde30ImgRetailV,
                },
            },
            CDE31: {
                name: "CDE31 Series",
                size: [
                    { id: "cde31_1", size: "43", model: "#CDE4331-1C" },
                    { id: "cde31_2", size: "55", model: "#CDE5531-1C" },
                    { id: "cde31_3", size: "65", model: "#CDE6531-1C" },
                    { id: "cde31_4", size: "75", model: "#CDE7531-1C" },
                    { id: "cde31_5", size: "86", model: "#CDE8631-1C" },
                    { id: "cde31_6", size: "98", model: "#CDE9831-1C" },
                ],
                inscreen_graphic: [
                    {
                        id: "cde31_inline_1",
                        label: "Corporate",
                        value: "crop",
                    },
                    {
                        id: "cde31_inline_2",
                        label: "Campus",
                        value: "campus",
                    },
                    {
                        id: "cde31_inline_3",
                        label: "Boardroom",
                        value: "board",
                    },
                    {
                        id: "cde31_inline_4",
                        label: "Retail",
                        value: "retail",
                    },
                ],
                orientation: [
                    {
                        id: "crop",
                        options: [
                            { id: "cde31_crop_h", label: "Horizontal", value: "", disabled: false },
                            { id: "cde31_crop_v", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                    {
                        id: "campus",
                        options: [
                            { id: "cde31_campus_h", label: "Horizontal", value: "", disabled: false },
                            { id: "cde31_campus_v", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                    {
                        id: "board",
                        options: [
                            { id: "cde31_board_h", label: "Horizontal", value: "", disabled: false },
                            { id: "cde31_board_v", label: "Vertical", value: "V", disabled: true },
                        ],
                    },
                    {
                        id: "retail",
                        options: [
                            { id: "cde31_retail_h", label: "Horizontal", value: "", disabled: false },
                            { id: "cde31_retail_v", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                ],
                imageMapping: {
                    crop: cde4331ImgH,
                    cropV: cde4331ImgV,
                    campus: cde31ImgCampus,
                    campusV: cde31ImgCampusV,
                    board: cde31ImgBoard,
                    retail: cde31ImgRetail,
                    retailV: cde31ImgRetailV,
                },
                imageMappingBySize: {
                    "#CDE4331-1C": {
                        crop: cde4331ImgH,
                        cropV: cde4331ImgV,
                    },
                    "#CDE5531-1C": {
                        crop: cde5531ImgH,
                        cropV: cde5531ImgV,
                    },
                    "#CDE6531-1C": {
                        crop: cde6531ImgH,
                        cropV: cde6531ImgV,
                    },
                    "#CDE7531-1C": {
                        crop: cde7531ImgH,
                        cropV: cde7531ImgV,
                    },
                    "#CDE8631-1C": {
                        crop: cde8631ImgH,
                        cropV: cde8631ImgV,
                    },
                    "#CDE9831-1C": {
                        crop: cde9831ImgH,
                        cropV: cde9831ImgV,
                    },
                },
            },
            CDE14: {
                name: "CDE14 Series",
                size: [
                    { id: "cde14_1", size: "43", model: "#CDE4314-2C" },
                    { id: "cde14_2", size: "50", model: "#CDE5014-2C" },
                    { id: "cde14_3", size: "55", model: "#CDE5514-2C" },
                    { id: "cde14_4", size: "65", model: "#CDE6514-2C" },
                    { id: "cde14_5", size: "75", model: "#CDE7514-2C" },
                    { id: "cde14_6", size: "86", model: "#CDE8614-2C" },
                ],
                inscreen_graphic: [
                    {
                        id: "cde14_inline_1",
                        label: "Corporate",
                        value: "crop",
                    },
                    {
                        id: "cde14_inline_2",
                        label: "Campus",
                        value: "campus",
                    },
                    {
                        id: "cde14_inline_3",
                        label: "Boardroom",
                        value: "board",
                    },
                    {
                        id: "cde14_inline_4",
                        label: "Retail",
                        value: "retail",
                    },
                ],
                orientation: [
                    {
                        id: "crop",
                        options: [
                            { id: "cde14_crop_h", label: "Horizontal", value: "", disabled: false },
                            { id: "cde14_crop_v", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                    {
                        id: "campus",
                        options: [
                            { id: "cde14_campus_h", label: "Horizontal", value: "", disabled: false },
                            { id: "cde14_campus_v", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                    {
                        id: "board",
                        options: [
                            { id: "cde14_board_h", label: "Horizontal", value: "", disabled: false },
                            { id: "cde14_board_v", label: "Vertical", value: "V", disabled: true },
                        ],
                    },
                    {
                        id: "retail",
                        options: [
                            { id: "cde14_retail_h", label: "Horizontal", value: "", disabled: false },
                            { id: "cde14_retail_v", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                ],
                imageMapping: {
                    crop: cde4314Img,
                    cropV: cde4314Img,
                    campus: cde14ImgCampus,
                    campusV: cde14ImgCampusV,
                    board: cde14ImgBoard,
                    retail: cde14ImgRetail,
                    retailV: cde14ImgRetailV,
                },
                imageMappingBySize: {
                    "#CDE4314-2C": { crop: cde4314Img, cropV: cde4314Img },
                    "#CDE5014-2C": { crop: cde5014Img, cropV: cde5014Img },
                    "#CDE5514-2C": { crop: cde5514Img, cropV: cde5514Img },
                    "#CDE6514-2C": { crop: cde6514Img, cropV: cde6514Img },
                    "#CDE7514-2C": { crop: cde7514Img, cropV: cde7514Img },
                    "#CDE8614-2C": { crop: cde8614Img, cropV: cde8614Img },
                },
            },
            CDEG3: {
                name: "CDEG3 Series",
                size: [
                    { id: "g3_1", size: "43", model: "#CDE43G3-1C" },
                    { id: "g3_2", size: "55", model: "#CDE55G3-1C" },
                    { id: "g3_3", size: "65", model: "#CDE65G3-1C" },
                    { id: "g3_4", size: "75", model: "#CDE75G3-1C" },
                    { id: "g3_5", size: "86", model: "#CDE86G3-1C" },
                    { id: "g3_6", size: "98", model: "#CDE98G3-1C" },
                ],
                inscreen_graphic: [
                    {
                        id: "g3_inline_1",
                        label: "Corporate",
                        value: "crop",
                    },
                    {
                        id: "g3_inline_2",
                        label: "Campus",
                        value: "campus",
                    },
                    {
                        id: "g3_inline_3",
                        label: "Boardroom",
                        value: "board",
                    },
                    {
                        id: "g3_inline_4",
                        label: "Retail",
                        value: "retail",
                    },
                ],
                orientation: [
                    {
                        id: "crop",
                        options: [
                            { id: "g3_crop_h", label: "Horizontal", value: "", disabled: false },
                            { id: "g3_crop_v", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                    {
                        id: "campus",
                        options: [
                            { id: "g3_campus_h", label: "Horizontal", value: "", disabled: false },
                            { id: "g3_campus_v", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                    {
                        id: "board",
                        options: [
                            { id: "g3_board_h", label: "Horizontal", value: "", disabled: false },
                            { id: "g3_board_v", label: "Vertical", value: "V", disabled: true },
                        ],
                    },
                    {
                        id: "retail",
                        options: [
                            { id: "g3_retail_h", label: "Horizontal", value: "", disabled: false },
                            { id: "g3_retail_v", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                ],
                imageMapping: {
                    crop: cde43g3Img,
                    cropV: cde43g3Img,
                    campus: cde43g3ImgCampus,
                    campusV: cde43g3ImgCampusV,
                    board: cde43g3ImgBoard,
                    retail: cde43g3ImgRetail,
                    retailV: cde43g3ImgRetailV,
                },
                imageMappingBySize: {
                    "#CDE43G3-1C": { crop: cde43g3Img, cropV: cde43g3Img },
                    "#CDE55G3-1C": { crop: cde55g3Img, cropV: cde55g3Img },
                    "#CDE65G3-1C": { crop: cde65g3Img, cropV: cde65g3Img },
                    "#CDE75G3-1C": { crop: cde75g3Img, cropV: cde75g3Img },
                    "#CDE86G3-1C": { crop: cde86g3Img, cropV: cde86g3Img },
                    "#CDE98G3-1C": { crop: cde98g3Img, cropV: cde98g3Img },
                },
            },
            CDEUW: {
                name: "CDE Ultrawide Series",
                size: [
                    { id: "option1", size: "92", model: "#CDE92UW" },
                ],
                inscreen_graphic: [
                    {
                        id: "inlineRadio1",
                        label: "Corporate",
                        value: "crop",
                    },
                    {
                        id: "inlineRadio2",
                        label: "Campus",
                        value: "campus",
                    },
                    {
                        id: "inlineRadio3",
                        label: "Boardroom",
                        value: "board",
                    },
                    {
                        id: "inlineRadio4",
                        label: "Retail",
                        value: "retail",
                    },
                ],
                orientation: [
                    {
                        id: "crop",
                        options: [
                            { id: "orientation1", label: "Horizontal", value: "", disabled: false },
                            { id: "orientation2", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                    {
                        id: "campus",
                        options: [
                            { id: "orientation1", label: "Horizontal", value: "", disabled: false },
                            { id: "orientation2", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                    {
                        id: "board",
                        options: [
                            { id: "orientation1", label: "Horizontal", value: "", disabled: false },
                            { id: "orientation2", label: "Vertical", value: "V", disabled: true },
                        ],
                    },
                    {
                        id: "retail",
                        options: [
                            { id: "orientation1", label: "Horizontal", value: "", disabled: false },
                            { id: "orientation2", label: "Vertical", value: "V", disabled: false },
                        ],
                    },
                ],
                imageMapping: {
                    crop: cde92uwCrop,
                    cropV: cde92uwCropV,
                    campus: cde92uwCampus,
                    campusV: cde92uwCampusV,
                    board: cde92uwBoard,
                    retail: cde92uwRetail,
                    retailV: cde92uwRetailV,
                },
            },
        },
    },
    allInOne: {
        seriesName: "All-in-One LED Displays",
        series: {
            LDS138151: {
                name: "LDS Series",
                feet: true,
                size: [{ id: "option1", size: "138", model: "#LDS138-151" }],
                inscreen_graphic: [
                    {
                        label: "Corporate",
                        value: "crop",
                        id: "inlineRadio1",
                    },
                    {
                        label: "Campus",
                        value: "campus",
                        id: "inlineRadio2",
                    },
                ],
                imageMapping: {
                    crop: lds138CropImg,
                    campus: lds138CampusImg,
                },
            },
            LDM: {
                name: "LDM Series",
                size: [
                    { id: "ldm_1", size: "136", model: "#ldm136-151" },
                    { id: "ldm_2", size: "163", model: "#ldm163-182" },
                    { id: "ldm_3", size: "231", model: "#ldm231-251" },
                ],
                inscreen_graphic: [
                    {
                        id: "ldm_inline_1",
                        label: "Corporate",
                        value: "crop",
                    },
                ],
                imageMapping: {
                    crop: ldm136Crop,
                },
                imageMappingBySize: {
                    "#ldm136-151": { crop: ldm136Crop },
                    "#ldm163-182": { crop: ldm163Crop },
                    "#ldm231-251": { crop: ldm231Crop },
                },
            },
            LDE: {
                name: "LDE Series",
                size: [
                    { id: "lde_1", size: "108", model: "#LDE108-123" },
                    { id: "lde_2", size: "136", model: "#LDE136G-152" },
                    { id: "lde_3", size: "163", model: "#LDE163G-182" },
                ],
                inscreen_graphic: [
                    {
                        id: "lde_inline_1",
                        label: "Corporate",
                        value: "crop",
                    },
                ],
                imageMapping: {
                    crop: lde136Photo,
                },
            },
            LDP: {
                name: "LDP Series",
                size: [
                    { id: "ldp_size_136", size: "136", model: "#LDP136-071C" },
                    { id: "ldp_size_163", size: "163", model: "#LDP163-091C" },
                    { id: "ldp_size_217", size: "217", model: "#LDP217-121C" },
                ],
                inscreen_graphic: [
                    {
                        id: "ldp_ig1",
                        label: "Corporate",
                        value: "crop",
                    },
                ],
                imageMapping: {
                    crop: ldp136Cover,
                },
                imageMappingBySize: {
                    "#LDP136-071C": {
                        crop: ldp136Cover,
                    },
                    "#LDP163-091C": {
                        crop: ldp163Cover,
                    },
                    "#LDP217-121C": {
                        crop: ldp163Cover,
                    },
                },
            },
            LDC027: {
                name: "LDC027 Series",
                hideSize: true,
                pixelPitch: [
                    {
                        id: "ldc027_pp_90",
                        label: "0.9",
                        model: "#LDC027G-091C",
                        disabled: true,
                    },
                    {
                        id: "ldc027_pp_120",
                        label: "1.2",
                        model: "#LDC027-120",
                        disabled: false,
                    },
                    {
                        id: "ldc027_pp_150",
                        label: "1.5",
                        model: "#LDC027-150",
                        disabled: false,
                    },
                    {
                        id: "ldc027_pp_180",
                        label: "1.8",
                        model: "#LDC027-180",
                        disabled: false,
                    },
                ],
                inscreen_graphic: [
                    {
                        id: "ldc027_ig1",
                        label: "Corporate",
                        value: "crop",
                    },
                ],
                imageMapping: {
                    crop: ldc027Cover,
                },
                imageMappingBySize: {
                    "#LDC027-120": {
                        crop: ldc027Cover,
                    },
                    "#LDC027-150": {
                        crop: ldc027Cover,
                    },
                    "#LDC027-180": {
                        crop: ldc027Cover,
                    },
                },
            },
            LDC027G: {
                name: "LDC027G Series",
                hideSize: true,
                pixelPitch: [
                    {
                        id: "ldc027g_pp_90",
                        label: "0.9",
                        model: "#LDC027G-091C",
                        disabled: false,
                    },
                    {
                        id: "ldc027g_pp_120",
                        label: "1.2",
                        model: "#LDC027G-121",
                        disabled: false,
                    },
                    {
                        id: "ldc027g_pp_150",
                        label: "1.5",
                        model: "#LDC027G-151",
                        disabled: false,
                    },
                    {
                        id: "ldc027g_pp_180",
                        label: "1.8",
                        model: "#LDC027G-181",
                        disabled: false,
                    },
                ],
                inscreen_graphic: [
                    {
                        id: "ldc027g_ig1",
                        label: "Corporate",
                        value: "crop",
                    },
                ],
                imageMapping: {
                    crop: ldc027Cover,
                },
                imageMappingBySize: {
                    "#LDC027G-091C": {
                        crop: ldc027Cover,
                    },
                    "#LDC027G-121": {
                        crop: ldc027Cover,
                    },
                    "#LDC027G-151": {
                        crop: ldc027Cover,
                    },
                    "#LDC027G-181": {
                        crop: ldc027Cover,
                    },
                },
            },
            LDC031: {
                name: "LDC031 Series",
                hideSize: true,
                pixelPitch: [
                    {
                        id: "ldc031_pp_120",
                        label: "1.2",
                        model: "#LDC031-120",
                        disabled: false,
                    },
                    {
                        id: "ldc031_pp_150",
                        label: "1.5",
                        model: "#LDC031-150",
                        disabled: false,
                    },
                    {
                        id: "ldc031_pp_180",
                        label: "1.8",
                        model: "#LDC031-180",
                        disabled: false,
                    },
                    {
                        id: "ldc031_pp_250",
                        label: "2.5",
                        model: "#LDC031-250",
                        disabled: false,
                    },
                ],
                inscreen_graphic: [
                    {
                        id: "ldc031_ig1",
                        label: "Corporate",
                        value: "crop",
                    },
                ],
                imageMapping: {
                    crop: ldc031Cover,
                },
                imageMappingBySize: {
                    "#LDC031-120": {
                        crop: ldc031Cover,
                    },
                    "#LDC031-150": {
                        crop: ldc031Cover,
                    },
                    "#LDC031-180": {
                        crop: ldc031Cover,
                    },
                    "#LDC031-250": {
                        crop: ldc031Cover,
                    },
                },
            },
            LDC031G: {
                name: "LDC031G Series",
                hideSize: true,
                pixelPitch: [
                    {
                        id: "ldc031g_pp_120",
                        label: "1.2",
                        model: "#LDC031G-121",
                        disabled: false,
                    },
                    {
                        id: "ldc031g_pp_150",
                        label: "1.5",
                        model: "#LDC031G-151",
                        disabled: false,
                    },
                    {
                        id: "ldc031g_pp_180",
                        label: "1.8",
                        model: "#LDC031G-181",
                        disabled: false,
                    },
                    {
                        id: "ldc031g_pp_250",
                        label: "2.5",
                        model: "#LDC031G-251",
                        disabled: false,
                    },
                ],
                inscreen_graphic: [
                    {
                        id: "ldc031g_ig1",
                        label: "Corporate",
                        value: "crop",
                    },
                ],
                imageMapping: {
                    crop: ldc031Cover,
                },
                imageMappingBySize: {
                    "#LDC031G-121": {
                        crop: ldc031Cover,
                    },
                    "#LDC031G-151": {
                        crop: ldc031Cover,
                    },
                    "#LDC031G-181": {
                        crop: ldc031Cover,
                    },
                    "#LDC031G-251": {
                        crop: ldc031Cover,
                    },
                },
            },
        },
    }
};

export default viewboardDetails;
